import { render, staticRenderFns } from "./Dialpad.vue?vue&type=template&id=15983b38&scoped=true"
import script from "./Dialpad.vue?vue&type=script&lang=js"
export * from "./Dialpad.vue?vue&type=script&lang=js"
import style0 from "./Dialpad.vue?vue&type=style&index=0&id=15983b38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15983b38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15983b38')) {
      api.createRecord('15983b38', component.options)
    } else {
      api.reload('15983b38', component.options)
    }
    module.hot.accept("./Dialpad.vue?vue&type=template&id=15983b38&scoped=true", function () {
      api.rerender('15983b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/Dialpad.vue"
export default component.exports